/* eslint-disable no-undef */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueBus from '@/libs/bus'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import TreeTable from 'tree-table-vue'
import Filter from './utils/filter'
// 打印
import Print from 'vue-print-nb'
Vue.prototype.$bus = VueBus
Vue.config.productionTip = false

Vue.prototype.$myRouter = router
Vue.prototype.$myStore = store

Vue.use(ElementUI)
Vue.use(TreeTable)
Vue.use(Print)
Vue.use(Filter)

if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  // eslint-disable-next-line camelcase
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
let instance = null
function render() {
  instance = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app_child')
  // index.html 里面的 id 需要改成 appVueHash，否则子项目无法独立运行
}

if (!window.__POWERED_BY_QIANKUN__) {
  // 全局变量来判断环境
  render()
}

/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap(props) {
  console.log('初始化', props)
  const { BASEURL, router, store, hasAuthority, token } = props
  // 当前是否是超管
  Vue.prototype.checkAdmin = function () {
    return store.state.user.userInfo.companyId === '1'
  }
  // 按钮权限控制
  Vue.prototype.$hasAuthority = hasAuthority
  Vue.prototype.$myRouter = router
  Vue.prototype.$myStore = store
  Vue.prototype.$BASEURL = BASEURL
}

/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props) {
  // console.log('进入微应用mount', props)
  render(props)
}

/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount() {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}

/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props) {
}
